/**
 * EXCLUSIVE CLUB SIGNUP HANDLER
 *
 * Handles the "Sign up" button on the exclusive-club page for non-logged-in users.
 * Opens the login drawer and shows the register page.
 *
 * In the Theme editor, sections are re-rendered without a full page reload.
 * We re-run `init()` on `shopify:section:load` to make sure event listeners
 * are attached whenever the exclusive-club content is injected.
 */

(function() {
  'use strict';

  const SIGNUP_SELECTOR = 'a[href*="#open-drawer-sign-up"]';
  const INITIALIZED_ATTR = 'data-ec-signup-initialized';

  const init = () => {
    const signupButtons = document.querySelectorAll(SIGNUP_SELECTOR);

    if (!signupButtons.length) {
      return;
    }

    signupButtons.forEach((button) => {
      if (button.getAttribute(INITIALIZED_ATTR) === 'true') return;

      button.setAttribute(INITIALIZED_ATTR, 'true');
      button.addEventListener('click', handleSignupClick);
    });
  };

  const handleSignupClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const registerButton = document.querySelector('[aria-controls="register"]');
    if (registerButton) {
      registerButton.click();
    }
  };

  // Initialize when DOM is ready (live storefront + initial editor load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when sections are loaded or re-rendered in the Theme editor
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    // Only re-init if this section actually contains our signup link(s)
    if (container.querySelector(SIGNUP_SELECTOR)) {
      init();
    }
  });
})();
